
import React, { useEffect, useRef, useState } from "react";
import NotificationAlert from "react-notification-alert";
import SpinsCategory from "../components/Notification/SpinsCategory.js"
import RatingCategory from "../components/Notification/RatingCategory.js"
import ProgressCategory from "../components/Notification/ProgressCategory.js"
import NotificationLogTable from "../components/Notification/NotificationLogTable.js"
import NotificationOverviewTable from "../components/Notification/NotificationOverviewTable.js"
import NotificationActiveChart from "../components/Notification/NotificationActiveChart.js";
import { NavLink, useParams } from "react-router-dom";
import { Button } from "reactstrap";

function Notification(props) {
    const notificationAlertRef = useRef(null);
    const { request_type } = useParams()
    const [requestType, setRequestType] = useState("")

    const notify = (place = 'tl', message = '', type = 'success', autoDismiss = 5) => {

        var options = {};
        options = {
            place: place,
            message: (
                <div>
                    {message}
                </div>
            ),
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: autoDismiss
        };
        notificationAlertRef.current.notificationAlert(options);
    }

    useEffect(() => {
        if (request_type === 'log') {
            setRequestType('log')
            document.title = 'Notification Log - TMH Admin';
        }
        else if (request_type === 'report') {
            setRequestType('report')
            document.title = 'Notification Report - TMH Admin';
        } else {
            setRequestType('config')
            document.title = 'Notification Config - TMH Admin';
        }
    }, [request_type])

    return (
        <div className="content">
            <div className="react-notification-alert-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>

            <div className="text-center mt-4 mb-4">
                <NavLink to="/notification/config">
                    <Button color={requestType === "config" ? "info" : "default"} className="btn btn-round">
                        Config
                    </Button>
                </NavLink>

                <NavLink to="/notification/log">
                    <Button color={requestType === "log" ? "info" : "default"} className="btn btn-round">
                        Log
                    </Button>
                </NavLink>

                <NavLink to="/notification/report">
                    <Button color={requestType === "report" ? "info" : "default"} className="btn btn-round">
                        Report
                    </Button>
                </NavLink>
            </div>
            {
                (requestType === "config") &&
                <>
                    <RatingCategory notify={notify} />
                    <SpinsCategory notify={notify} />
                    <ProgressCategory notify={notify} />
                </>
            }
            {
                (requestType === "log") &&
                <>
                    <NotificationOverviewTable />
                    <NotificationLogTable />
                </>
            }

            {(requestType === "report") &&
                <>
                    <NotificationActiveChart />
                </>
            }
        </div>
    );
}

export default Notification;
